export const TFA_STATE = {
    LOADING: "loading",
    PAGE_READY: "ready",
}

export const TFA_STATE_MESSAGE_MAP = {
    [TFA_STATE.LOADING]: "",
    [TFA_STATE.PRE_LOADING]: "",
}